export const getOtherLocale = (locale) => (locale === 'pl' ? 'en' : 'pl')
